// extracted by mini-css-extract-plugin
export var chevronIcon = "_9z-2";
export var teamName = "_9z-1";
export var teamSwitcherButton = "_9z-0";